/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { useBreakpoint } from '@one-thd/sui-atomic-components';
import { createPortal } from 'react-dom';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Sticky } from '@thd-olt-component-react/sticky';
import classNames from 'classnames';
import { DraggableDrawer } from './MagicApronAssistant/subcomponents/drawer/DraggableDrawer';
import { getPortalRootNode } from '../utils/assistant-utils';
import { useZIndexManager } from '../hooks/useZIndexManager';
import './ResponsiveAssistant.scss';

export const ResponsiveAssistant = ({ drawerState, setDrawerState, offsetMargin, children = null }) => {
  const { lesser: isMobile } = useBreakpoint('lg');
  const portalRootNode = getPortalRootNode();

  useEffect(() => {
    const rootEl = document.getElementById('root');
    // Add/remove CSS class based on current breakpoint
    if (!isMobile && rootEl) {
      rootEl.classList.add('magic-apron-assistant-root');
    } else if (rootEl) {
      rootEl.classList.remove('magic-apron-assistant-root');
    }

    return () => {
      if (!isMobile && rootEl) {
        rootEl.classList.remove('magic-apron-assistant-root');
      }
    };
  }, [isMobile]);

  // Manage z-index of LiveChat elements when drawer state is OPEN
  useZIndexManager('#spr-live-chat-app > div', 900, drawerState === 'OPEN');

  const stickyClassnames = classNames('sui-w-full sui-left-0 sui-transition-[bottom]', {
    '!sui-duration-500': offsetMargin > 0
  });

  return (
    <ErrorBoundary name="magic-apron-assistant-with-portal">
      <>
        {isMobile && (
          // StickyWithHeaderObserver has z-index of 899 that we can't override so need to wrap to be on top of header/footer
          // eslint-disable-next-line tailwindcss/no-arbitrary-value
          <div className="sui-z-[998] sui-relative">
            {/* Overlay to darken background when drawer is open */}
            {drawerState === 'OPEN' && <div className="sui-fixed sui-inset-0 sui-bg-inverse/50" />}
            <Sticky
              className={stickyClassnames}
              position="bottom"
              stickyByDefault
              visibleByDefault
              offsetMargin={offsetMargin}
            >
              <DraggableDrawer
                drawerState={drawerState}
                setDrawerState={setDrawerState}
              >
                {children}
              </DraggableDrawer>
            </Sticky>
          </div>
        )}
        {!isMobile && (portalRootNode !== null ? createPortal(
          <aside
            id="magic-apron-assistant-drawer"
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="sui-sticky sui-flex sui-flex-col sui-h-[calc(100vh-169px)] sui-top-[169px] sui-ml-3 sui-mr-8 sui-border-solid sui-border-1 sui-border-primary"
          >
            {children}
          </aside>, portalRootNode
        ) : (
          <aside
            id="magic-apron-assistant-drawer"
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="sui-sticky sui-flex sui-flex-col sui-h-[calc(100vh-169px)] sui-top-[169px] sui-ml-3 sui-mr-8 sui-border-solid sui-border-1 sui-border-primary"
          >
            {children}
          </aside>
        ))}
      </>
    </ErrorBoundary>
  );
};